/**
 * Renders the page controls
 */
import React from "react";

export default class extends React.Component {
  /**
   * Is fired when the page view-mode icon is selected
   */
  handleFitPageWidthClick(event) {
    event.preventDefault();
    this.props.onFitPageChange(true);
  }

  /**
   * Is fired when the full view-mode icon is selected
   */
  handleFitPageHeightClick(event) {
    event.preventDefault();
    this.props.onFitPageChange(false);
  }

  /**
   * Is fired when download button is clicked
   */
  handleDownloadCick(event) {
    event.preventDefault();
    this.props.onDownload(false);
  }

  /**
   * Zooms in page
   */
  handleZoomIn(event) {
    event.preventDefault();
    this.props.onZoomIn();
  }

  /**
   * Zooms out page
   */
  handleZoomOut(event) {
    event.preventDefault();
    this.props.onZoomOut();
  }

  render() {
    var download;

    if(this.props.allowDownload) {
      download = (
        <div className="document-viewer-page-controls-right">
          <a
            href="#"
            className="icon-download space-r1 document-viewer-page-controls-link"
            href={this.props.downloadUrl}
            target="_blank"
            download>
            Download
          </a>
        </div>
      );
    }

    return (
      <div className="document-viewer-page-controls">
        <div className="document-viewer-page-controls-left">
          <a
            href="#"
            className="document-viewer-page-controls-icon document-viewer-page-controls-icon-zoom-out space-r1"
            onClick={this.handleZoomOut.bind(this)}
          />
          <a
            href="#"
            className="document-viewer-page-controls-icon document-viewer-page-controls-icon-zoom-in space-r1"
            onClick={this.handleZoomIn.bind(this)}
          />

          <div className="document-viewer-page-controls-separator space-r1" />

          <a
            href="#"
            className="document-viewer-page-controls-icon document-viewer-page-controls-icon-page space-r1"
            onClick={this.handleFitPageHeightClick.bind(this)}
          />
          <a
            href="#"
            className="document-viewer-page-controls-icon document-viewer-page-controls-icon-full"
            onClick={this.handleFitPageWidthClick.bind(this)}
          />
        </div>
        {download}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./app/javascript/portal/document_viewer/controls.jsx